<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Stock Transfer Products List</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/stock-reports">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-autocomplete autocomplete="off" dense outlined v-model="FromStore" :items="stores" label="From Shop"
              item-text="Name" item-value="id"></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete autocomplete="off" dense outlined v-model="ToStore" :items="stores" label="To Store"
              item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="3">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="StartDate" label="From Date"
                  prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker v-model="StartDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" sm="12" md="3">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="EndDate" label="To" prepend-icon="mdi-calendar-month"
                  v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker v-model="EndDate" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="6">
            <v-autocomplete style="width: 500px" autocomplete="off" v-model="select" :items="products"
              :search-input.sync="searchProducts" item-text="Name" item-value="id" cache-items class="mt-2" flat
              hide-no-data hide-details label="Search Product" outlined dense>
            </v-autocomplete>
          </v-col>

          <v-col cols="3">
            <v-btn color="primary" @click="getRecords">Query Data</v-btn>
          </v-col>
        </v-row>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-text-field v-model="search" label="Search" outlined dense></v-text-field>
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="headers" :items="stockTransfers"
              :search="search">
              <template v-slot:item.date="{ item }">
                {{ item.date | date }}
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- pdf preview -->
        <pdf-preview ref="pdfPreview"></pdf-preview>
        <!-- snackbar -->
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { generatePdf } from "@/common/transferMethods.js";
export default {
  data() {
    return {
      products: [],
      search: null,
      select: "",
      pageItems: 100,
      menu1: false,
      menu2: false,
      StartDate: null,
      EndDate: null,
      FromStore: null,
      ToStore: null,
      PickedBy: null,
      loader: false,
      stores: [],
      users: [],
      searchProducts: null,
      headers: [
        { text: "Product", value: "product.Name" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit", value: "uom.UomName" },
        { text: "From Shop", value: "fromStore.Name" },
        { text: "To Store", value: "toStore.Name" },
        { text: "Date", value: "date" },
      ],
      stockTransfers: [],
    };
  },
  computed: {
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
    totalAmount() {
      let total = 0;
      if (
        typeof this.stockTransfers != "undefined" &&
        this.stockTransfers.length > 0
      ) {
        return this.stockTransfers
          .map((item) => {
            const amount = item.Quantity * item.BuyingPrice;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    generatePdf,
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      var customerId = 0;

      // if (this.record.CardCode) {
      //   customerId = this.record.CardCode;
      // }

      const data = {
        SearchText: searchText,
        CustomerId: customerId
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords() {
      const self = this;
      var productId = 0;

      if(self.select != "") {
        productId = parseInt(self.select);
      } 

      const data = {
        StartDate: self.StartDate,
        EndDate: self.EndDate,
        FromStore: self.FromStore,
        ToStore: self.ToStore,
        ProductId: productId
      };

      self.loader = true;
      const url = `/stock-transfer-products`;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          console.log(res, " transfer products ");
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.stockTransfers = res.ResponseData;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getStores()]);
  },
};
</script>

<style lang="scss" scoped></style>